import styled, { css } from 'styled-components';
import Icon, { ICON_SIZES } from '../../icon';
import Typography from '../../typography';
import { pxToRem } from '../../../design-tokens/style-utilities';
const ICON_SIZE = 'xl';
/**
 * Card header
 */
export const CardHeaderContainerStyles = ({ theme, $collapsable, $collapsed, $editable, $useRedesign, }) => css `
	position: relative;
	display: block;
	height: auto;
	min-height: ${pxToRem(theme.spacing['400'])};
	color: ${theme.colors.base.textTitles};
	pointer-events: none;

	${!$useRedesign &&
    css `
		margin-bottom: ${pxToRem(theme.spacing['200'])};
	`}

	${$useRedesign &&
    css `
		border-radius: 0;
		padding: ${pxToRem(theme.spacing['100'])};
		background-color: ${theme.colors.extralight.bgCards};
	`}

	${$collapsable &&
    css `
		pointer-events: auto;

		${$collapsed &&
        css `
			margin-bottom: 0;
		`}
	`}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		${$useRedesign &&
    css `
			border-radius: ${pxToRem(theme.borderRadius.s)} ${pxToRem(theme.borderRadius.s)} 0 0;
		`}

		${$editable &&
    css `
			padding-right: ${pxToRem(theme.spacing['700'])};
		`}
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		margin-bottom: ${pxToRem(theme.spacing['300'])};

		${$useRedesign &&
    css `
			margin-bottom: 0;
		`}
	}

	&:focus {
		outline: 0;
	}

	${$collapsable &&
    css `
		cursor: pointer;

		${!$collapsed &&
        css `
			pointer-events: auto;
		`}
	`}
`;
export const CardHeaderContainer = styled.header `
	${CardHeaderContainerStyles}
`;
/**
 * Card header title
 */
export const cardHeaderTitleStyles = ({ theme, $useRedesign, }) => css `
	display: flex;
	line-height: 1;
	align-items: center;

	${$useRedesign &&
    css `
		padding: 0 ${pxToRem(theme.spacing['100'])};
	`}
`;
export const CardHeaderTitle = styled.div `
	${cardHeaderTitleStyles}
`;
/**
 * Card icon conteiner
 */
export const cardIconContainerStyles = ({ theme }) => css `
	position: relative;
	width: ${pxToRem(Number(ICON_SIZES[ICON_SIZE]) + Number(theme.spacing['100']) * 2)};
	height: ${pxToRem(Number(ICON_SIZES[ICON_SIZE]) + Number(theme.spacing['100']) * 2)};
	margin-right: ${pxToRem(theme.spacing['200'])};
	border-radius: 50%;
	background: ${theme.colors.blanc.bgCards};
`;
export const CardIconContainer = styled.span `
	${cardIconContainerStyles}
`;
/**
 * Card icon
 */
export const cardIconStyles = ({ theme }) => css `
	color: ${theme.colors.base.iconUi};
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;
export const CardIcon = styled(Icon).attrs({
    size: ICON_SIZE,
}) `
	${cardIconStyles}
`;
/**
 * Card toggle icon
 */
export const cardToggleIconStyles = ({ theme, $useRedesign, }) => css `
	position: absolute;
	top: 50%;
	right: ${pxToRem(theme.spacing['200'])};
	transform: translateY(-50%);
	color: ${theme.colors.highlight.iconInteractive};

	${$useRedesign &&
    css `
		right: ${pxToRem(theme.spacing['300'])};
	`}
`;
export const CardToggleIcon = styled(Icon) `
	${cardToggleIconStyles}
`;
/**
 * Card title
 */
export const cardTitleStyles = () => css `
	display: block;
	margin: 0;
	word-break: break-word;
`;
export const CardTitle = styled(Typography) `
	${cardTitleStyles}
`;
/**
 * Card extras
 */
export const cardExtrasStyles = ({ theme, $collapsable, $editable, $useRedesign, $loading, $icon, }) => css `
	display: ${$editable ? 'block' : 'none'} !important;
	margin-bottom: ${pxToRem(theme.spacing['100'])};

	${$useRedesign &&
    css `
		margin-bottom: 0;
		background-color: ${theme.colors.extralight.bgCards};
		padding-bottom: ${pxToRem(theme.spacing['100'])};
		padding-left: ${pxToRem(theme.spacing['300'])};
	`}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		position: absolute;
		top: ${pxToRem(theme.spacing['100'])};
		right: ${pxToRem(theme.spacing['300'])};

		${$useRedesign &&
    css `
			top: ${pxToRem(theme.spacing['100'])};
			right: ${pxToRem(theme.spacing['200'])};
			padding-bottom: 0;
			padding-left: 0;
		`}

		${$collapsable &&
    css `
			right: ${pxToRem(theme.spacing['600'])};
		`}
		${$collapsable &&
    $editable &&
    css `
			right: ${pxToRem(theme.spacing['600'])};
		`}
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		top: ${pxToRem(theme.spacing['300'])};
		right: ${pxToRem(theme.spacing['400'])};

		${$useRedesign &&
    css `
			top: ${pxToRem(theme.spacing['100'])};
			right: ${pxToRem(theme.spacing['300'])};

			${$collapsable &&
        $editable &&
        css `
				right: ${pxToRem(theme.spacing['600'])};
			`}
		`}
	}

	${$icon &&
    css `
		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			top: ${pxToRem(theme.spacing['200'])};
			right: ${pxToRem(theme.spacing['400'])};

			${$useRedesign &&
        css `
				right: ${pxToRem(theme.spacing['300'])};
			`}

			${$collapsable &&
        $editable &&
        css `
				right: ${pxToRem(theme.spacing['600'])};
			`}
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			top: ${pxToRem(theme.spacing['400'])};

			${$useRedesign &&
        css `
				top: ${pxToRem(theme.spacing['200'])};
			`}
		}
	`}

	${$loading &&
    css `
		display: none;
	`}
`;
export const CardExtras = styled.div `
	${cardExtrasStyles}
`;
